import { User } from './user';

export default class LoggedAction {
  by?: User;
  date?: Date;
}
